export default async function UpdatePlotSequence(sendForm) {
    let url = window.RealestateService+  `/api/ProjectPlotDetails/UpdatePlotSequence`
    let head = {
        "content-type":"application/json",
        "accept":"*/*"
    }
    let data ={}
    let response  = await fetch(url, {
        method:"PUT",
        headers:head,
        body:JSON.stringify(sendForm)
    }).then(res=>res.json()).then(data)

    return response
}